/**
 * The merchant workspace vocabulary — every string the wireframe shows, in
 * English and Arabic. Pages read from here so the two languages cannot
 * drift, and so no page invents copy the wireframe does not have.
 */

import { homeCopyAr, homeCopyEn } from './copy/homeCopy.js';
import {
  productionLinesCopyAr,
  productionLinesCopyEn,
} from './copy/productionLinesCopy.js';
import { profileCopyAr, profileCopyEn } from './copy/profileCopy.js';
import { settingsCopyAr, settingsCopyEn } from './copy/settingsCopy.js';
import { shellCopyAr, shellCopyEn } from './copy/shellCopy.js';
import { videosCopyAr, videosCopyEn } from './copy/videosCopy.js';

export type WorkspaceLanguage = 'en' | 'ar';

const en = {
  ...shellCopyEn,
  ...homeCopyEn,
  ...productionLinesCopyEn,
  ...videosCopyEn,
  ...profileCopyEn,
  ...settingsCopyEn,
};

export type WorkspaceCopy = typeof en;

const ar: typeof en = {
  ...shellCopyAr,
  ...homeCopyAr,
  ...productionLinesCopyAr,
  ...videosCopyAr,
  ...profileCopyAr,
  ...settingsCopyAr,
};

export const WORKSPACE_COPY: Readonly<Record<WorkspaceLanguage, WorkspaceCopy>> = {
  en,
  ar,
};

export function workspaceCopy(language: WorkspaceLanguage): WorkspaceCopy {
  return WORKSPACE_COPY[language];
}
